<template>
  <div class="depoWidhd-wrap">
    <div class="list-header">
      <div class="list-nav">
        <div class="nav-left">
          <span style="margin: 0 3px">날짜</span>
          <DatePic
            v-model:value="from"
            format="YYYY-MM-DD"
            value-type="format"
          />
          <span style="margin: 0 3px">~</span>
          <DatePic v-model:value="to" format="YYYY-MM-DD" value-type="format" />
          <button @click="searchDate()" style="margin-left: 3px">
            기간검색
          </button>
          <input
            type="button"
            :value="$moment(date).subtract(1, 'days').format('YYYY-MM-DD')"
            @click="searchDate($event.target.value)"
            style="margin-left: 20px"
          />
          <span style="margin: 0 3px">{{ date }}</span>
          <input
            type="button"
            :value="$moment(date).add(1, 'days').format('YYYY-MM-DD')"
            @click="searchDate($event.target.value)"
          />
        </div>
        <!--"nav-left -->
        <div class="nav-right">
          <span>회원보유머니:</span
          ><span style="color: red; margin-right: 5px">{{
            $addCommas(totalAmount.userMoney)
          }}</span>
          <span>총충전머니:</span
          ><span style="color: red; margin-right: 5px">{{
            $addCommas(totalAmount.depositAmount)
          }}</span>
          <span>총환전머니:</span
          ><span style="color: red; margin-right: 5px">{{
            $addCommas(totalAmount.withdrawalAmount)
          }}</span>
          <span>총손익금액:</span
          ><span style="color: red">{{
            $addCommas(totalAmount.depositAmount - totalAmount.withdrawalAmount)
          }}</span>
        </div>
        <!-- nav-right -->
      </div>
      <!-- list-nav -->
    </div>
    <!-- list-header -->
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalAmount: {},
      from: this.$moment().format("YYYY-MM-DD"),
      to: this.$moment().format("YYYY-MM-DD"),
      date: this.$moment().format("YYYY-MM-DD"),
    };
  },
  watch: {
    $route(to, from) {
      if (from !== to) {
        if (this.$route.query.from) {
          this.date = this.$route.query.from;
        }
      }
    },
  },
  mounted() {
    this.getTotalAmount();
  },
  methods: {
    //총 충환전 헤더
    getTotalAmount() {
      this.$axios
        .get(`/transaction/summary?from=${this.from}&to=${this.to}`)
        .then((res) => {
          if (res) {
            this.totalAmount = res.data;
          }
        });
    },
    searchDate(e) {
      if (this.from > this.to)
        return alert("시작일보다 이후 날짜를 선택해주세요");
      if (e) {
        this.from = e;
        this.to = e;
      }
      this.$router.push(`${this.$route.path}?from=${this.from}&to=${this.to}`);
      this.getTotalAmount();
    },
  },
};
</script>
